// Port of api/fuel/app/classes/controller/api/monty/languages/suggest.php
import DB from 'offline/db'
import Util from 'offline/util'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	var exclude = params.exclude || [0]
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })
	var rows = DB.query("SELECT language_id, language_name FROM language WHERE LOWER(language_name) LIKE '%" + text.replace(/'/g, "''") + "%' AND language_id NOT IN(" + Util.in(exclude) + ") LIMIT 25")
	var suggestions = {}
	for (var i = 0; i < rows.length; i++) suggestions[rows[i].language_id] = { id: rows[i].language_id, name: rows[i].language_name }
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
